import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnIT: CultureInfo = {
  name: 'en-IT',
  displayName: 'English (Italy)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-IT',
  parent: CultureInfoEn
};
